import { render, staticRenderFns } from "./Task.vue?vue&type=template&id=168ebdf4&scoped=true"
import script from "./Task.vue?vue&type=script&lang=js"
export * from "./Task.vue?vue&type=script&lang=js"
import style0 from "./Task.scss?vue&type=style&index=0&id=168ebdf4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168ebdf4",
  null
  
)

export default component.exports